import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/button';
import Icon from '../../../components/appIcon';
import Modal from 'components/ui/modal';

const AttendanceEditModal = ({ record, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        checkIn: '',
        checkOut: '',
        status: '',
        notes: '',
        location: ''
    });

    useEffect(() => {
        if (record) {
            // Convert UTC date to local date string for datetime-local input
            const formatToLocalDateTime = (dateString) => {
                if (!dateString) return '';
                const date = new Date(dateString);
                // Get year, month, day, hours, minutes in local timezone
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            };

            setFormData({
                checkIn: formatToLocalDateTime(record.checkIn),
                checkOut: formatToLocalDateTime(record.checkOut),
                status: record.status || '',
                notes: record.notes || '',
                location: record.location || ''
            });
        }
    }, [record]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Convert local datetime back to ISO string (UTC)
        const convertToUTC = (localDateTime) => {
            if (!localDateTime) return null;
            const date = new Date(localDateTime);
            return date.toISOString();
        };

        const updatedData = {
            ...formData,
            // checkIn: convertToUTC(formData.checkIn),
            checkIn: formData.checkIn || null,
            checkOut: formData.checkOut || null,
            // checkOut: convertToUTC(formData.checkOut)
        };
        onSave(updatedData);
    };

    return (
        <Modal isOpen={true} onClose={onClose}>
            <div className="bg-card rounded-lg p-6">
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-bold">Edit Attendance Record</h2>
                    <Button variant="ghost" size="icon" onClick={onClose}>
                        <Icon name="X" size={20} />
                    </Button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">Check In</label>
                            <input
                                type="datetime-local"
                                name="checkIn"
                                value={formData.checkIn}
                                onChange={handleChange}
                                className="w-full p-2 border border-border rounded"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Check Out</label>
                            <input
                                type="datetime-local"
                                name="checkOut"
                                value={formData.checkOut}
                                onChange={handleChange}
                                className="w-full p-2 border border-border rounded"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Status</label>
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className="w-full p-2 border border-border rounded"
                            >
                                <option value="present">Present</option>
                                <option value="late">Late</option>
                                <option value="absent">Absent</option>
                                <option value="early_departure">Early Departure</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Location</label>
                            <input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                className="w-full p-2 border border-border rounded"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Notes</label>
                            <textarea
                                name="notes"
                                value={formData.notes}
                                onChange={handleChange}
                                className="w-full p-2 border border-border rounded"
                                rows={3}
                            />
                        </div>
                    </div>
                    <div className="flex justify-end space-x-2 mt-6">
                        <Button type="button" variant="outline" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="submit">
                            Save Changes
                        </Button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default AttendanceEditModal;